// @flow
import Resource from 'speed-js-core/src/api/Resource';

export default class DeviceRegisterResource extends Resource {
    basePath: string = 'devices/register/';

    objectPath: string = 'devices/register/{ident}/';
}
